import { render, staticRenderFns } from "./serverProvider.vue?vue&type=template&id=e8df2ca2&"
import script from "./serverProvider.vue?vue&type=script&lang=js&"
export * from "./serverProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports